import { StaticImageData } from 'next/image'

const caratMap: Record<string, string> = {
  '1.25': 'VeryBig',
  '1.1': 'Big',
  '1': 'Medium',
  '0.9': 'Small',
  '0.75': 'VerySmall',
}

let imageCache: Record<string, StaticImageData> = {}

export function preloadGfImages() {
  if (typeof window === 'undefined') return

  const req = require.context('../assets/gf-nfts', false, /\.webp$/)

  req.keys().forEach((key: string) => {
    const mod = req(key) as { default: StaticImageData }
    const fileName = key.replace('./', '')
    imageCache[fileName] = mod.default
  })
}

// export function getGfImageFromAttributes(
//   color: string,
//   shape: string,
//   clarity: string,
//   cut: string,
//   carat: string,
// ): string | null {
//   const caratLabel = caratMap[carat]
//   if (!caratLabel) return null

//   const fileName = `HODLGemstone_Preview_${color}_${shape}_${clarity}_${cut}_${caratLabel}_0.webp`

//   return imageCache[fileName] ?? null
// }

export function getGfImage(fileName: string): StaticImageData | null {
  return imageCache[fileName] ?? null
}
